<template>
  <div>
    <div class="container">
      <div class="filterBox flex wrap">
        <div class="box flex">
          <div class="label">反馈来源</div>
          <el-select v-model="from" placeholder="请选择" style="width: 160px">
            <el-option
              v-for="item in fromList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="box flex">
          <div class="label">提交日期</div>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="search"
            style="width: 225px"
          />
        </div>
        <div class="box flex">
          <div class="label">用户昵称</div>
          <el-input v-model="nick_name" style="width: 160px" @change="search" />
        </div>
        <div class="box flex">
          <div class="label">用户电话</div>
          <el-input v-model="phone" style="width: 160px" @change="search" />
        </div>
        <div class="box flex">
          <div class="label">处理日期</div>
          <el-date-picker
            v-model="settle_time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="search"
            style="width: 225px"
          />
        </div>
        <div class="box flex">
          <div class="label">处理人</div>
          <el-input
            v-model="admin_name"
            style="width: 160px; margin-right: 10px"
            @change="search"
          />
          <el-button type="info" class="search-button" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <!-- 表格 -->
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column label="反馈来源" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.from == 1">用户app</div>
              <div v-if="scope.row.from == 2">诊疗小程序</div>
              <div v-if="scope.row.from == 3">商城小程序</div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="提交日期" width="100" />
          <el-table-column label="用户信息" width="200">
            <template slot-scope="scope">
              <p>{{ scope.row.nick_name }}</p>
              <div class="align-center">
                <span> {{ scope.row.user_phone }}</span>
                <img
                  v-if="
                    scope.row.user_phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(5, scope.row.user_id)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="160">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.image.length > 0"
                :src="scope.row.image[0]"
                :preview-src-list="scope.row.image"
              />
            </template>
          </el-table-column>
          <el-table-column prop="content" label="意见反馈" />
          <el-table-column prop="phone" label="联系电话" width="200">
            <template slot-scope="scope">
              <div class="align-center">
                <span> {{ scope.row.phone }}</span>
                <img
                  v-if="
                    scope.row.phone &&
                    (module_id_array[0]
                      ? module_id_array.includes('1756')
                      : true)
                  "
                  class="phone-box"
                  src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                  alt
                  @click="callBtn(8, scope.row.id)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="处理人" width="110">
            <template slot-scope="scope">
              <div>{{ scope.row.admin_name }}</div>
              <div>{{ scope.row.result_time }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="business_type" label="问题分类" width="100" />
          <el-table-column label="处理结果" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.is_result == 1">已解决</div>
              <div v-if="scope.row.is_result == 2">未解决</div>
            </template>
          </el-table-column>
          <el-table-column prop="result_desc" label="处理意见" />
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin: 20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      nick_name: "",
      phone: "",
      admin_name: "",
      time: [],
      settle_time: [],
      from: 0,
      fromList: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "用户app",
        },
        {
          value: 2,
          label: "诊疗小程序",
        },
        {
          value: 3,
          label: "商城小程序",
        },
      ],
      settleDia: false,
      queList: [
        {
          value: "物流问题",
          label: "物流问题",
        },
        {
          value: "退款问题",
          label: "退款问题",
        },
      ],
      ruleForm: {
        id: "",
        business_type: "",
        is_result: "",
        result_desc: "",
      },
      rules: {
        business_type: [
          {
            required: true,
            message: "选择问题类型",
            trigger: "blur",
          },
        ],
        is_result: [
          { required: true, message: "请确认处理结果", trigger: "blur" },
        ],
        result_desc: [
          { required: true, message: "请输入处理意见", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //获取认证记录列表
    getList() {
      let data = {
        nick_name: this.nick_name,
        phone: this.phone,
        from: this.from,
        status: 1,
        admin_name: this.admin_name,
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      if (this.time && this.time.length > 0) {
        data.start_time = dayjs(this.time[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.time[1]).format("YYYY-MM-DD");
      }
      if (this.settle_time && this.settle_time.length > 0) {
        data.result_start_time = dayjs(this.settle_time[0]).format(
          "YYYY-MM-DD"
        );
        data.result_end_time = dayjs(this.settle_time[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/activity/getUserFeedbackList", data)
        .then((res) => {
          let list = res.data.list;
          list.forEach((ele) => {
            ele.create_time = dayjs
              .unix(ele.create_time)
              .format("YYYY-MM-DD HH:mm");
            ele.result_time = dayjs
              .unix(ele.result_time)
              .format("YYYY-MM-DD HH:mm");
          });
          this.totalNum = res.data.total;
          this.tableData = list;
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    Settle(id) {
      this.ruleForm = {
        id: id,
        business_type: "",
        is_result: 1,
        result_desc: "",
      };
      this.settleDia = true;
    },
    //添加反馈处理
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          this.axios
            .post("platform/Activity/dealUserFeedback", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("保存成功！");
                this.settleDia = false;
                this.getList();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.phone-box {
  width: 18px;
  height: 18px;
  padding: 0 6px;
  cursor: pointer;
}
.filterBox {
  .box {
    line-height: 40px;
    height: 40px;
    margin-right: 20px;
    margin-bottom: 20px;
    .label {
      margin-right: 10px;
      width: 70px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: auto;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
</style>
